import React, { createContext, useContext, useEffect, useState } from 'react'
import { delay } from '../Functions/DelayFn'
import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import scanSound from '../Assets/Sounds/barcodeReader.mp3'

interface GlobalContextType {
  playScanSound: any
  setLoadingDialog: any
}

const GlobalContext = createContext<GlobalContextType>({} as GlobalContextType)
export const useGlobalContext = () => useContext(GlobalContext)

function GlobalTriggers({ children }: { children: any }) {
  const [playingSound, playScanSound] = useState(false)
  const [loadingDialog, setLoadingDialog] = useState(false)

  useEffect(() => {
    const playSound = async () => {
      // console.log('playing sound')
      playScanSound(true)
      await delay(3000)
    }

    if (playingSound) {
      playSound().then(() => {
        playScanSound(false)
      })
    }
  }, [playScanSound, playingSound])

  return (
    <GlobalContext.Provider
      value={{
        playScanSound,
        setLoadingDialog,
      }}
    >
      {children}
      {playingSound && process.env.REACT_APP_STAGE === 'production' && (
        <audio
          aria-label={'Playing Sound'}
          src={scanSound}
          controls
          autoPlay
        />
      )}
      <Dialog open={loadingDialog}>
        <DialogTitle>{'Loading...'}</DialogTitle>
        <DialogContent>
          <CircularProgress style={{ margin: 20 }} />
        </DialogContent>
      </Dialog>
    </GlobalContext.Provider>
  )
}

export default GlobalTriggers
